import equal from "fast-deep-equal"

export function compareDeep(value1: any, value2:any) {
  return equal(value1, value2)
}
